"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m12.55 7.87h-1.55v4.28h1.15a4 4 0 0 0 2.32-.62 1.8 1.8 0 0 0 .86-1.59 1.8 1.8 0 0 0 -.66-1.56 4 4 0 0 0 -2.12-.51z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.17 0h-22.34a.84.84 0 0 0 -.83.84v22.33a.83.83 0 0 0 .83.83h22.34a.83.83 0 0 0 .83-.83v-22.33a.84.84 0 0 0 -.83-.84zm-7.38 12.92a5.22 5.22 0 0 1 -3.5 1h-1.11v4.34h-2.58v-12.2h3.89a5.19 5.19 0 0 1 3.38 1 3.7 3.7 0 0 1 1.13 2.8 4 4 0 0 1 -1.21 3.06z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m.3 11.21h23.41v1.57h-23.41z",
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 -4.97 12)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m12 1.57a10.43 10.43 0 1 1 -10.43 10.43 10.44 10.44 0 0 1 10.43-10.43m0-1.57a12 12 0 1 0 12 12 12 12 0 0 0 -12-12z"
  })));
};

exports["default"] = _default;